var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.name)?_c('h2',{domProps:{"textContent":_vm._s(_vm.name)}}):_vm._e(),_c('publications',{attrs:{"type":"articles","section-id":_vm.id,"detail-route-name":"ArticleDetail","more-text":"Узнать больше"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }